class loadingButton extends HTMLElement {
  constructor() {
    super();
    this.url = '';
    this.totalProducts = 0;
    this.loadedProducts = 0;
    this.progressBar = this.querySelector('.progress-bar');
    this.progressBar.value = this.loadedProducts;
    this.resultCount = this.querySelector('.result-count');
    this.automaticLoading = this.getAttribute('automatic-loading');
    this.loadButtonContainer = this.closest('.pagination-wrapper');
    this.loadButton =  this.querySelector('button');
    this.loadPreviousButton =  document.querySelector('#load-previous-items');
    this.productContainer =  document.querySelector('#product-grid');
    this.articleContainer =  document.querySelector('#article-grid');
    this.vanillaPagination =  document.querySelector('#pagination');
    this.loadButton.addEventListener(
      'click',
      this.loadMore.bind(this)
    );
    if (this.loadPreviousButton) {
      this.loadPreviousButton.addEventListener(
        'click',
        this.loadPrevious.bind(this)
      );
    }

    // loading observer
    let options = {
      root: null,
      rootMargin: "0px",
      threshold: 0.25
    };
    this.observer = new IntersectionObserver(this.handleIntersection, options);
  }

  connectedCallback() {
    if (this.automaticLoading === 'true' ) {
      this.observer.observe(this.loadButton);
    }
    this.fetchCurrentPage();
    this.loadedProducts = parseInt(this.loadButton.getAttribute('data-loaded-products-total'));
    this.totalProducts = parseInt(this.loadButton.getAttribute('data-total-results-count'));
    this.updateProgress();
    document.addEventListener('click', this.gridItemLinkInterceptor.bind(this));
  }



  handleIntersection(entries) {
    entries.forEach(entry => {
      if (entry.intersectionRatio > 0) {
        entry.target.closest('loading-button').loadMore();
      }
    });
  }

  fetchCurrentPage() {
    // check if url had page param, is so fetch that page and replace product grid items
    let url = new URL(window.location.href);
    let page = url.searchParams.get("page");
    if (page) {
      this.url = url.href;
      this.fetchCurrentPageItems(this.url);
    }
  }

  // intercepts product card and article card links and updates the url with the page number
  gridItemLinkInterceptor(e) {
    if (e.target.closest('quickbuy-button') || e.target.closest('product-form') || e.target.closest('.product-card__wishlist-button')) { // TODO: replace '.product-card__wishlist-button' with actuall swymwishlist selector for PC
      return;
    } else if (e.target.closest('product-card') && e.target.closest('#product-grid')) {
      e.preventDefault();
      let url = new URL(window.location.href);
      let page = e.target.closest('product-card').dataset.productPaginationPage;
      url.searchParams.set("page", page);
      window.history.pushState({ path: url.href }, '', url.href);
      window.location.href = e.target.closest('product-card').querySelector('a').href;
    } else if (e.target.closest('.article-card') && e.target.closest('#article-grid')) {
      e.preventDefault();
      let url = new URL(window.location.href);
      let page = e.target.closest('.article-card').dataset.articlePaginationPage;
      url.searchParams.set("page", page);
      window.history.pushState({ path: url.href }, '', url.href);
      window.location.href = e.target.closest('.article-card').href;
    } else if (e.target.closest('.js-search-page-card') && e.target.closest('#product-grid')) {
      e.preventDefault();
      let url = new URL(window.location.href);
      let page = e.target.closest('.js-search-page-card').dataset.pagePaginationPage;
      url.searchParams.set("page", page);
      window.history.pushState({ path: url.href }, '', url.href);
      window.location.href = e.target.closest('.js-search-page-card').href || e.target.href;
    } else {
      return;
    }
  }

  loadPrevious() {
    // get url from window
    let prevUrl = new URL(window.location.href);
    this.prevPage = this.loadPreviousButton.dataset.previousPage;
    prevUrl.searchParams.set("page", this.prevPage);
    this.loadPreviousButton.classList.add('loading');
    this.loadPreviousButton.querySelector('.loading-overlay__spinner').classList.remove('hidden');
    this.fetchPreviousItems(prevUrl.href);
  }

  loadMore() {
    this.url = document.querySelector('.pagination-wrapper a.pagination__item--next').href;
    this.loadButton.classList.add('loading');
    this.loadButton.querySelector('.loading-overlay__spinner').classList.remove('hidden');
    this.fetchItems(this.url);
  }

  fetchPreviousItems(url) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        if (url.includes("blog")) this.renderPreviousItemsArticleGrid(html);
        else this.renderPreviousItemsProductGrid(html);
        this.updateProgress();
        this.hideLoadPreviousButton();
        this.prevLoadingButtonChecker();
        this.loadPreviousButton.dataset.previousPage = parseInt(this.prevPage) - 1;
      });
  }

  fetchItems(url) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        if (url.includes("blog")) this.renderArticleGrid(html);
        else this.renderProductGrid(html);
        this.renderNewNavigation(html);
        this.loadingButtonChecker();
        this.updateProgress();
        this.updateUrl();
      });
  }

  fetchCurrentPageItems(url) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        if (url.includes("blog")) this.renderCurrentPageArticleGrid(html);
        else this.renderCurrentPageProductGrid(html);
        this.renderNewNavigation(html);
        this.loadingButtonChecker();
        this.updateProgress();
        this.updateUrl();
      });
  }

  updateUrl() {
    let newUrl = new URL(this.url);
    let page = newUrl.searchParams.get("page");
    let newPage = parseInt(page);
    newUrl.searchParams.set("page", newPage);
    this.url = newUrl.href;
    // updating browser history
    window.history.pushState({ path: newUrl.href }, '', newUrl.href);
  }

  listenForParamsChange() {
    window.addEventListener('popstate', (event) => {
      this.url = event.state.path;
      this.fetchItems(this.url);
    });
  }

  renderProductGrid(html) {
    let newPage = new DOMParser().parseFromString(html, 'text/html').getElementById('product-grid').innerHTML
    this.productContainer.innerHTML = this.productContainer.innerHTML + newPage;
    this.loadedProducts = this.productContainer.querySelectorAll('product-card').length;
  }

  renderPreviousItemsProductGrid(html) {
    let newPage = new DOMParser().parseFromString(html, 'text/html').getElementById('product-grid').innerHTML
    this.productContainer.innerHTML = newPage + this.productContainer.innerHTML;
    this.loadedProducts = this.productContainer.querySelectorAll('product-card').length;
  }

  renderCurrentPageProductGrid(html) {
    let newPage = new DOMParser().parseFromString(html, 'text/html').getElementById('product-grid').innerHTML
    this.productContainer.innerHTML =  newPage;
    this.loadedProducts = this.productContainer.querySelectorAll('product-card').length;
  }

  renderCurrentPageArticleGrid(html) {
    let newPage = new DOMParser().parseFromString(html, 'text/html').getElementById('article-grid').innerHTML
    this.articleContainer.innerHTML = newPage;
    this.loadedArticles = this.articleContainer.querySelectorAll('.article').length;
  }

  renderArticleGrid(html) {
    let newPage = new DOMParser().parseFromString(html, 'text/html').getElementById('article-grid').innerHTML
    this.articleContainer.innerHTML = this.articleContainer.innerHTML + newPage;
    this.loadedArticles = this.articleContainer.querySelectorAll('.article').length;
  }

  renderPreviousItemsArticleGrid(html) {
    let newPage = new DOMParser().parseFromString(html, 'text/html').getElementById('article-grid').innerHTML
    this.articleContainer.innerHTML = newPage + this.articleContainer.innerHTML;
    this.loadedArticles = this.articleContainer.querySelectorAll('.article').length;
  }

  renderNewNavigation(html) {
    this.vanillaPagination.innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('pagination').innerHTML;
  }

  loadingButtonChecker() {
    this.loadButton.classList.remove('loading');
    this.loadButton.querySelector('.loading-overlay__spinner').classList.add('hidden');
    if (document.querySelectorAll('.pagination-wrapper a.pagination__item--next').length === 0) {
      this.loadButtonContainer.classList.add('hidden');
    }
  }

  prevLoadingButtonChecker() {
    this.loadPreviousButton.classList.remove('loading');
    this.loadPreviousButton.querySelector('.loading-overlay__spinner').classList.add('hidden');
  }

  updateProgress() {
    let progress = (this.loadedProducts / this.totalProducts) * 100;
    this.progressBar.setAttribute("style", "--progress:" + `${progress}` + "%");
    this.resultCount.textContent = `Showing ${this.loadedProducts} of ${this.totalProducts}`;
  }

  hideLoadPreviousButton() {
    if (this.prevPage == 1) {
      this.loadPreviousButton.classList.add('hidden');
    }
  }
}

customElements.define('loading-button', loadingButton);